import apiClient from "@/api/apiClient";

export const getCategories = async () => {
  const result = await apiClient.get("/api/categories");
  return result.data.categories;
};
